class MmxPdpTestimonialsSwiper {
  constructor(section) {
    this.section = section;
    this.swiperEl = section.querySelector('.mmx-pdp-testimonials__swiper');
    this.swiper = null;

    if (!this.swiperEl) return;

    this.init();
  }

  init() {
    if (typeof Swiper === 'undefined') {
      this._initAttempts = (this._initAttempts || 0) + 1;
      if (this._initAttempts < 40) {
        window.setTimeout(() => this.init(), 50);
      }
      return;
    }

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    const paginationEl = this.section.querySelector('.mmx-pdp-testimonials__pagination');
    const autoPlay = this.section.dataset.autoPlay === 'true';
    const autoplaySpeed = Number(this.section.dataset.autoplaySpeed) * 1000 || 5000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
    const cardsGap =
      parseFloat(getComputedStyle(this.section).getPropertyValue('--mmx-pdp-t-cards-gap')) * rootFontSize || 40;

    const config = {
      init: false,
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 450,
      grabCursor: slideCount > 1,
      watchOverflow: true,
      resistanceRatio: 0.65,
      breakpoints: {
        750: {
          slidesPerView: slideCount > 1 ? 2 : 1,
          spaceBetween: cardsGap,
        },
      },
    };

    if (paginationEl && slideCount > 1) {
      config.pagination = {
        el: paginationEl,
        type: 'bullets',
        clickable: true,
        bulletClass: 'mmx-pdp-testimonials__dot',
        bulletActiveClass: 'is-active',
        renderBullet(index, className) {
          return `<button type="button" class="${className}" role="tab" aria-label="Testimonial ${index + 1}"></button>`;
        },
      };
    }

    if (autoPlay && slideCount > 1 && !reducedMotion) {
      config.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    this.swiper = new Swiper(this.swiperEl, config);
    this.swiper.init();
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

const initMmxPdpTestimonialsSection = (section) => {
  if (!section) return;

  if (section._mmxPdpTestimonialsSwiper) {
    section._mmxPdpTestimonialsSwiper.destroy();
  }

  section._mmxPdpTestimonialsSwiper = new MmxPdpTestimonialsSwiper(section);
};

const bootMmxPdpTestimonials = () => {
  document.querySelectorAll('[data-mmx-pdp-testimonials]').forEach(initMmxPdpTestimonialsSection);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootMmxPdpTestimonials);
} else {
  bootMmxPdpTestimonials();
}

document.addEventListener('shopify:section:load', (event) => {
  initMmxPdpTestimonialsSection(event.target.querySelector('[data-mmx-pdp-testimonials]'));
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('[data-mmx-pdp-testimonials]');
  if (section?._mmxPdpTestimonialsSwiper) {
    section._mmxPdpTestimonialsSwiper.destroy();
    delete section._mmxPdpTestimonialsSwiper;
  }
});
